import React from 'react';
import {Icon, Pagination, Table} from "antd";
import {injectIntl} from "react-intl";
import moment from 'moment';
import Constants from "../../../services/Constants";
import DayWithWeek from "../../common/format/DayWithWeek";
import FromToDates from "./FromToDates";

import "./PlanningTable.css";

const Column = Table.Column;

class PlanningTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ...this.initParameters(props)
    }
  }

  initParameters = (props) => {
    const {from, to, page = 1, pageSize = 10, sizeOptions = ["10", "25", "50", "100"]} = props;
    return {
      from, to,
      page, pageSize, sizeOptions
    };
  };

  componentDidMount() {
    const {page, pageSize, from, to} = this.state;
    this.props.onDataUpdate(page - 1, pageSize, from, to);
  }

  onPageOptionsChange = (page, pageSize) => {
    const {from, to} = this.state;
    this.setState({page, pageSize});
    this.props.onDataUpdate(page - 1, pageSize, from, to);
  };

  computeColor = (availability) => {
    if (!availability || availability.dayStatus === 'CLOSED') {
      return "calendar-box--closed";
    }

    switch (availability.rentalStatus) {
      case 'AVAILABLE':
        return "calendar-box--available";
      case 'NOT_AVAILABLE':
        return "calendar-box--closed";
      case 'RENTED':
        return "calendar-box--unavailable";
      default :
        return 'calendar-box--no-rental';
    }
  };

  onFromDateChange = (e) => {
    const {page, pageSize, to} = this.state;
    const date = e ? moment(e).format(Constants.DATE_FORMAT_API) : null;
    this.setState({from: date});
    this.props.onDataUpdate(page - 1, pageSize, date, to);
  };

  onToDateChange = (e) => {
    const {page, pageSize, from} = this.state;
    const date = e ? moment(e).format(Constants.DATE_FORMAT_API) : null;
    this.setState({to: date});
    this.props.onDataUpdate(page - 1, pageSize, from, date);
  };

  disabledTime = (date) => {
    const {from} = this.state;
    return date && date < moment(from).endOf('day');
  };

  renderColumns = (from, to) => {
    if (!from || !to) {
      return null;
    }

    const columns = [];

    for (let current = moment(from); !current.isAfter(moment(to)); current.add(1, 'days')) {
      const selectedDate = moment(current).format(Constants.DATE_FORMAT_API);
      const selectedCss = moment().format(Constants.DATE_FORMAT_API) === selectedDate ? "selected" : "";

      columns.push(
        <Column
          title={<DayWithWeek date={selectedDate}/>}
          key={moment(current).format(Constants.DATE_FORMAT_API)}
          className={`park-column ${selectedCss}`}
          render={(text, record) => {
            const availability = record.availabilities[selectedDate] || {};
            const colorClass = this.computeColor(availability);

            if (availability.rentalDetails) {
              const {rentalDetails} = availability
              if (rentalDetails.rentingJourney) {
                return <div className={`park-case ${colorClass}`} onClick={() => this.props.onSelect && this.props.onSelect({...availability.rentalDetails}, record.rentalVehicle)}><Icon type="info-circle"/></div>
              }
              if (rentalDetails.rentingCustomer) {
                return <div className={`park-case ${colorClass}`} onClick={() => this.props.onManualBooking && this.props.onManualBooking({...availability.rentalDetails, rentalAvailability: record.availabilities})}><Icon type="info-circle"/></div>
              }
            }
            return <div className={`park-case ${colorClass}`} onClick={() => availability.rentalStatus === 'AVAILABLE' && this.props.onManualBooking && this.props.onManualBooking({rentalVehicle: record.rentalVehicle, rentingCustomer: {from: selectedDate, to: selectedDate}, rentalAvailability: record.availabilities})}/>

          }}
        />
      )
    }
    return columns;
  };

  render() {
    const {intl: {formatMessage}, loading, totalElements, additionalColumns, rentalPark, deactivateDates = false, errors} = this.props;
    const {page, sizeOptions, from, to} = this.state;

    return (
      <div>
        {deactivateDates === false &&
          <FromToDates className="right form-field form-field--inline"
                       onFromChange={this.onFromDateChange} onToChange={this.onToDateChange}
                       from={from} to={to} error={errors} disabledTo={this.disabledTime}/>
        }

        <div className="table-wrapper__body">
          <div className="fc fc-unthemed fc-ltr">
            <Table dataSource={rentalPark} rowKey={(record) => record.rentalVehicle.vin} scroll={{x: 1000}} loading={loading} pagination={false}>
              {additionalColumns}
              <Column
                title={formatMessage({id: 'vehicle.category'})}
                key="category"
                fixed='left'
                width={110}
                render={(text, record) => formatMessage({id: `mobility.${record.rentalVehicle.category}`})}
              />
              <Column
                title={formatMessage({id: 'vehicle.vin'}) + ' / ' + formatMessage({id: 'vehicle.serialNumber'})}
                key="vin"
                fixed='left'
                width={110}
                render={(text, record) => record.rentalVehicle.vin}
              />
              <Column
                title={formatMessage({id: 'vehicle.make'})}
                key="make"
                fixed='left'
                width={110}
                render={(text, record) => record.rentalVehicle.brand}
              />
              <Column
                title={formatMessage({id: 'vehicle.model'})}
                key="model"
                fixed='left'
                width={110}
                render={(text, record) => record.rentalVehicle.model}
              />
              <Column
                title={formatMessage({id: 'vehicle.plate'})}
                key="licensePlate"
                fixed='left'
                width={110}
                render={(text, record) => record.rentalVehicle.licensePlate}
              />
              <Column
                title={formatMessage({id: 'vehicle.gearbox'})}
                key="gearbox"
                fixed='left'
                width={110}
                render={(text, record) => record.rentalVehicle.gearbox ? formatMessage({id: `vehicle.gearbox.${record.rentalVehicle.gearbox}`}) : undefined}
              />

              {/* It is necessary to have an empty column with no width in order for the component to scale correctly on X */}
              <Column key="space"/>

              {this.renderColumns(from, to, rentalPark)}
            </Table>
          </div>

          <ul className="calendar-legend justify-content-end">
            <li><span className="fc-event-dot calendar-legend__color--green"/>&nbsp;{formatMessage({id: 'appointment.planning.available'})}</li>
            <li><span className="fc-event-dot calendar-legend__color--orange"/>&nbsp;{formatMessage({id: 'appointment.planning.assigned'})}</li>
            <li><span className="fc-event-dot calendar-legend__color--red"/>&nbsp;{formatMessage({id: 'appointment.planning.rented'})}</li>
          </ul>
        </div>

        <footer className="table-wrapper__footer">
          <Pagination className="pagination" current={page}
                      defaultCurrent={1} onChange={this.onPageOptionsChange}
                      showSizeChanger onShowSizeChange={this.onPageOptionsChange}
                      pageSizeOptions={sizeOptions} defaultPageSize={Number.parseInt(sizeOptions[0], 0)}
                      total={totalElements}
          />
        </footer>
      </div>
    );
  }
}

export default injectIntl(PlanningTable);
